// パスワード忘れ : パスワードを忘れた際のパスワード再設定処理 /password_register2
import React, { Component } from 'react';
import ToggleDisplay from 'react-toggle-display';
import Header from './header';
import Footer from './footer';
import './css/passwordReset.css';
import firebase from "firebase";
import { browserHistory } from 'react-router';
import cryptojs from 'crypto-js';
import define from './define';

const delimiter = '{{{{{}}}}}';

export default class passwordReset2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      passwordAgain: '',
      isInvalidPass: false,
      errorMessage: '',
    }
  }

  componentWillMount = () => {
    const query = this.props.location.query.m;
    if (!query) {
      // アカウント連携トップへ遷移
      browserHistory.push('/newflow1');
    }
  }

  handleChangePassword = (e) => {
    this.setState({ password: e.target.value });
  }

  handleChangePasswordAgain = (e) => {
    this.setState({ passwordAgain: e.target.value });
  }

  setPassword = async (e) => {
    if (0 === this.state.password.length) {
      this.setState({ errorMessage: '※パスワードを入力してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (0 === this.state.passwordAgain.length) {
      this.setState({ errorMessage: '※確認用パスワードを入力してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (this.state.password !== this.state.passwordAgain) {
      this.setState({ errorMessage: '※パスワードが一致しません。再度入力してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (!this.state.password.match(/[A-Z]/)) {
      // 大文字
      this.setState({ errorMessage: '※最低１文字の英大文字を設定してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (!this.state.password.match(/[a-z]/)) {
      // 小文字
      this.setState({ errorMessage: '※最低１文字の英小文字を設定してください' });
      this.setState({ isInvalidPass: true });
      return;
    } else if (!this.state.password.match(/\d/)) {
      // 数字
      this.setState({ errorMessage: '※最低１文字の数字を設定してください' });
      this.setState({ isInvalidPass: true });
      return;
    }

    // URLクエリ取得とデコード
    const query = this.props.location.query.m;
    const decodedUrlQueries = this.decoding(query);
    const decodedUid = decodedUrlQueries[2];
    const decodedEmail = decodedUrlQueries[0];

    // メールアドレスを持つユーザーオブジェクトを取得
    let headers = new Headers()
    headers.append('Content-Type','application/json')
    let endPoint = '/api/getUser'
    let options = {
      method:'POST',
      headers: headers,
      body:JSON.stringify({ uid: decodedUid })
    }

    const res = await fetch(endPoint,options)
    const user = await res.json()

    const decryptedPass = cryptojs.AES.decrypt(user.password, define.ENV.passwordSecret).toString(cryptojs.enc.Utf8);
    // パスワード更新のために一度ログイン
    await firebase.auth().signInWithEmailAndPassword(decodedEmail, decryptedPass);
    const currentUser = firebase.auth().currentUser;
    currentUser.updatePassword(this.state.password)
      .then(async() => {
        // 暗号化してパスワード更新
        const cipher = cryptojs.AES.encrypt(this.state.password, define.ENV.passwordSecret).toString();
        const updates = {}
        updates['users/' + currentUser.uid + '/password'] = cipher;
        await firebase.database().ref().update(updates);
        // ライセンスページへ
        browserHistory.push("/user/" + currentUser.uid);
      })
      .catch(err => {
        // update failure
        if ('auth/weak-password' === err.code) {
          this.setState({ errorMessage: '※最低6文字で設定してください'} );
          this.setState({ isInvalidPass: true });
          return;
        }
        console.log(err)
      })
  }

  decoding = (query) => {
    return Buffer.from(query,'base64').toString().split(delimiter);
  }

  render () {
    return (
      <div id="wrapper">
        <div id="" className="wrapper-lp wrapper-passwordReset1">
          <Header />
          <div className="webWrap">
            <div className="wrapCover">
              <div className="wrapCover__contentBlock clearfix">
                <div className="content-top">
                  <div className="block-passwordReset1">
                    <h2 className="title">パスワード再設定</h2>
                    <p className="password-term">
                      パスワードは最低６文字、且つ１文字以上の大文字・小文字・数字を含む必要があります。
                    </p>
                    <form className="form-password-reset">
                    <ToggleDisplay if={ this.state.isInvalidPass }>
                      <p>{this.state.errorMessage}</p>
                    </ToggleDisplay>
                      <input type="password" placeholder="パスワードを入力ください" onChange={e => this.handleChangePassword(e)}></input>
                      <input type="password" placeholder="パスワードを再度入力ください" onChange={e => this.handleChangePasswordAgain(e)}></input>
                      <button className="submit" type="button" onClick={e => this.setPassword(e)}>設定する</button>
                    </form>
                  </div>
                </div>
              </div>
              <Footer/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/passwordReset2.js